import React from "react";
import { motion } from "framer-motion";
import { getBadges } from "../lib/store";
import { Footprints, Flame, BookCheck, Target, Star, CalendarCheck, GraduationCap, Trophy, Lock, Award } from "lucide-react";

const ICONS = { Footprints, Flame, BookCheck, Target, Star, CalendarCheck, GraduationCap, Trophy };

export function BadgesGrid({ level }) {
  const badges = getBadges(level);
  const earnedCount = badges.filter((b) => b.earned).length;
  return (
    <div className="rounded-2xl border border-border bg-card p-6" data-testid="badges-section">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-2">
          <Award size={18} className="text-warning" />
          <h2 className="font-display font-bold text-lg">Badges</h2>
        </div>
        <span className="font-mono text-xs text-muted-foreground" data-testid="badges-count">{earnedCount}/{badges.length} débloqués</span>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-3">
        {badges.map((b, i) => {
          const Icon = ICONS[b.icon] || Award;
          return (
            <motion.div
              key={b.id}
              initial={{ opacity: 0, scale: 0.92 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ delay: Math.min(i * 0.04, 0.4) }}
              data-testid={`badge-${b.id}`}
              title={b.desc}
              className={`flex flex-col items-center text-center gap-2 rounded-xl border p-3 transition-colors ${
                b.earned ? "border-warning/40 bg-warning/5" : "border-border bg-muted/30 opacity-70"
              }`}
            >
              <span
                className={`relative grid place-items-center w-12 h-12 rounded-full ${
                  b.earned ? "bg-warning/15 text-warning" : "bg-muted text-muted-foreground"
                }`}
                style={b.earned ? { filter: "drop-shadow(0 0 6px hsl(var(--warning) / 0.35))" } : undefined}
              >
                <Icon size={22} />
                {!b.earned && (
                  <span className="absolute -bottom-1 -right-1 grid place-items-center w-5 h-5 rounded-full bg-background border border-border">
                    <Lock size={10} className="text-muted-foreground" />
                  </span>
                )}
              </span>
              <div className="font-display font-semibold text-[13px] leading-tight">{b.label}</div>
              <div className="text-[11px] text-muted-foreground leading-snug">{b.desc}</div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}
